import { render } from "./TagPublicView.vue?vue&type=template&id=a913fa3c"
import script from "./TagPublicView.vue?vue&type=script&lang=js"
export * from "./TagPublicView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__